import megaNavStyles from "./mega-nav.module.css";

export function LinkContent({ link }) {
  return (
    <div class="mb-4">
      <h3 class={`${megaNavStyles["heading"]} mb-2`}>
        {link.megaMenu.heading}
      </h3>
      <p class={`${megaNavStyles["text"]} mb-3`}>{link.megaMenu.text}</p>
      {link.megaMenu.link.name && link.megaMenu.link.url && (<a href={link.megaMenu.link.url} class="button button-megamenu">
        {link.megaMenu.link.name}
      </a>)}
    </div>
  );
}